export const LEAD_STATUS = {
  WON: 2,
}



// WEBPACK FOOTER //
// ./src/modules/leads/domain/data/lead.status.data.js